import { QuoteType } from "@/components/widgets/Quote/type";
import type { ViewId } from "@/shared/types/common";

export const UserRoles = {
	BRONZE: "bronze" as const,
	SILVER: "silver" as const,
	GOLD: "gold" as const,
	PLATINUM: "platinum" as const,
	UNAUTHENTICATED: "unauthenticated" as const,
} as const;

export const PREMIUM_ROLES: UserRole[] = ["silver", "gold", "platinum"];

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];

const UNAUTHENTICATED_WIDGETS: ViewId[] = [
	"Chart",
	"Screener",
	"Monitor",
	"Markets",
	"Quote",
	"Navigation",
];
const BRONZE_WIDGETS: ViewId[] = [...UNAUTHENTICATED_WIDGETS, "Chat"];
const SILVER_WIDGETS: ViewId[] = [
	...BRONZE_WIDGETS,
	"News",
	"Financials",
	"Advanced Quote",
];
const GOLD_WIDGETS: ViewId[] = [
	...SILVER_WIDGETS,
	"Earnings Analysis",
	"Drift Forecast",
	"Holders",
	"Elements",
];

const PLATINUM_WIDGETS: ViewId[] = [...GOLD_WIDGETS, "Backtest"];

export const WIDGETS_BY_ROLE: Record<UserRole, ViewId[]> = {
	unauthenticated: UNAUTHENTICATED_WIDGETS,
	[UserRoles.BRONZE]: BRONZE_WIDGETS,
	[UserRoles.SILVER]: SILVER_WIDGETS,
	[UserRoles.GOLD]: GOLD_WIDGETS,
	[UserRoles.PLATINUM]: PLATINUM_WIDGETS,
};

export const COMING_SOON_WIDGETS: readonly ViewId[] = [
	"Dark Short",
	"Holdings",
	"Insiders",
] as const;

export const ADVANCED_QUOTE = QuoteType.ADVANCED;
